import { isRejectedWithValue } from '@reduxjs/toolkit'
import { unAuthenticate } from 'features/auth/authSlice'

export const unauthenticatedMiddleware = api => next => action => {
    if (isRejectedWithValue(action) && action.payload.status === 401) {
        api.dispatch(unAuthenticate())
    }

    return next(action)
}
